"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const expressions_1 = require("@mwater/expressions");
const valueFormatter_1 = require("../valueFormatter");
const valueFormatter_2 = require("../valueFormatter");
/** Component that displays hover over content */
const HoverContent = (props) => {
    const [values, setValues] = (0, react_1.useState)({});
    const [error, setError] = (0, react_1.useState)(null);
    const exprUtils = new expressions_1.ExprUtils(props.schema);
    (0, react_1.useEffect)(() => {
        let mounted = true;
        const items = props.items;
        if (items.length > 0) {
            props.mapLayerDataSource.getHoverOverData(props.design, props.data, props.filters).then((data) => {
                if (mounted) {
                    setValues(data);
                }
            }).catch((error) => {
                if (mounted) {
                    setError(error.message);
                }
            });
        }
        return () => {
            mounted = false;
        };
    }, []);
    if (error) {
        return react_1.default.createElement("div", { className: "text-danger" }, error);
    }
    return (react_1.default.createElement("div", { className: "_mviz-map-hover-content" }, props.items.map((item) => {
        let value = values[item.id];
        if (value != null && item.value) {
            // Get expression type
            const exprType = exprUtils.getExprType(item.value);
            // Format if can format
            if (exprType && (0, valueFormatter_1.canFormatType)(exprType)) {
                value = (0, valueFormatter_2.formatValue)(exprType, value, item.format, props.locale);
            }
            else {
                value = exprUtils.stringifyExprLiteral(item.value, value, props.locale);
            }
        }
        else {
            value = "■■■■";
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", null,
                props.translate(item.label),
                ":"),
            react_1.default.createElement("span", { className: "text-muted" }, values[item.id] === null ? "n/a" : value)));
    })));
};
exports.default = HoverContent;
